export const slugifyCatalogTemplate = (name) => {
  const base = String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  if (!base) return '';
  return base.slice(0, 80);
};

export const resolveCatalogTemplateSlug = (name, slug) => {
  const trimmedSlug = String(slug || '').trim().toLowerCase();
  if (trimmedSlug) return trimmedSlug;
  return slugifyCatalogTemplate(name);
};
